import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { userSubOrderGetIsSubOrderCancellablePerItem } from '../../../../order'
import {
  urlResolverGetOrderQuestionsCancellablePage,
  urlResolverGetProductsCancellationPage,
} from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutCancelOrderCta: FC<
  ContactPageSelfServiceShortcutProps
> = () => {
  const globalConfig = useGlobalConfigContext()
  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder
  const orderNumber = lastOrder?.orderMasterData?.orderNumber
  const subOrderId = subOrder?.subOrderId

  if (!subOrder || !subOrderId || !orderNumber) {
    return null
  }

  const hasCancellationPerItem =
    subOrder.orderDocuments !== undefined &&
    userSubOrderGetIsSubOrderCancellablePerItem(subOrder)

  const href = hasCancellationPerItem
    ? urlResolverGetProductsCancellationPage(
        globalConfig,
        orderNumber,
        subOrderId,
      )
    : urlResolverGetOrderQuestionsCancellablePage(
        globalConfig,
        orderNumber,
        subOrderId,
      )

  return (
    <Button<'a'>
      color="secondary"
      href={href}
      size="small"
      slots={{ root: 'a' }}
    >
      <FormattedMessage id="direct.contact.form.order.cancellation" />
    </Button>
  )
}
